import React from "react";
import AppIcon from "./AppIcon";

const SORT_OPTIONS = [
  { key: "nearest", label: "براساس نزدیکترین" },
  { key: "newest", label: "براساس جدیدترین" },
  { key: "store_name", label: "براساس نام فروشگاه" },
  { key: "customer_name", label: "براساس نام مشتری" },
  { key: "orders_least", label: "براساس کمترین سفارش" },
  { key: "orders_most", label: "براساس بیشترین سفارش" },
];

const SortModal = ({ activeSort, onSelect, onClose }) => {
  return (
    <div className="sort-modal">
      <div className="sort-modal-head">
        <h2>
          <AppIcon name="sort" width={22} height={22} alt="" />
          مرتب‌سازی
        </h2>
        <button type="button" className="sort-modal-close" onClick={onClose} aria-label="بستن">
          ×
        </button>
      </div>
      <div className="sort-modal-options">
        {SORT_OPTIONS.map((option) => (
          <button
            key={option.key}
            type="button"
            className={`sort-modal-option ${activeSort === option.key ? "active" : ""}`}
            onClick={() => onSelect(option.key)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SortModal;
